import { ASSETS } from "../../config";

export const VslPlayer = ({ testId = "vsl-player" }) => (
  <div
    data-testid={testId}
    className="relative aspect-video w-full overflow-hidden rounded-2xl border-2 border-gold shadow-[0_0_60px_-18px_rgba(255,211,77,0.45)]"
  >
    <iframe
      src={`${ASSETS.vslUrl}?rel=0&modestbranding=1`}
      title="Tempio Vivo — La nostra storia e il metodo"
      className="h-full w-full"
      allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      referrerPolicy="strict-origin-when-cross-origin"
      allowFullScreen
      data-testid="vsl-iframe"
    />
  </div>
);
